<template>
  <main class="page">
    <div class="p-5">
      <BError v-if="error">{{ ['oktaUnauthorized', 'featureUnauthorized', 'featureUnauthorizedNoRedirect', 'noRegionsError', 'regionsError'].find(e=>e === error) | translate(labels,'shared_CommonErrors') }} {{ message }}</BError>
    </div>
  </main>
</template>

<script>
import BError from '@/components/ui/BError'

export default {
  conceptName: ['shared_CommonErrors'],
  components: {BError},
  data() {
    return {
      error: null,
      message: null,
      redirect: false,
      redirectTimer: null
    }
  },
  watch: {
    $route() {
      this.handleErrorMessage()
    },
    labels(l) {
      if (l['shared_CommonFunctional'] && this.redirect) this.startTimer()
    }
  },
  beforeMount() {
    this.handleErrorMessage()
  },
  beforeDestroy() {
    clearTimeout(this.redirectTimer)
  },
  methods: {
    handleErrorMessage() {
      if (this.$route.query.error && this.$route.query.error.length > 0) { //got error code from okta
        this.error = this.$route.query.error || this.error
        this.message = this.$route.query.message || null
        if (this.$route.query.redirect) {
          this.redirect = true
          if (this.labels['shared_CommonFunctional']) this.startTimer()
        }
        this.$router.replace({query: {}}).catch(() => {})
      }
    },
    startTimer() {
      if (this.redirectTimer === null) {
        const timeout = parseInt(this.translatedLabel('redirectAfterSec', 'shared_CommonFunctional'))
        const path = this.translatedLabel('redirectPath', 'shared_CommonFunctional')
        this.redirectTimer = setTimeout(() => document.location.href = path, timeout * 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-top: 4rem;
}
</style>
